import { FC } from 'react';
import { DEBIN_LOADING_MESSAGES } from '../../constants/data';
import { TextLoadingAnimation } from '../shared/TextLoadingAnimation';
import { Spinner } from '../shared/Spinner';
import { VStack } from '@bpba/ui-components';

export const DebinAnimation: FC = () => {
  return (
    <VStack my={'48px'} fontWeight={600}>
      <Spinner width={40} />
      <TextLoadingAnimation messages={DEBIN_LOADING_MESSAGES} />
    </VStack>
  );
};
